module.exports = __webpack_public_path__ + "img/ed43711a975c80f5f10e84cc7407d37d.png";